export const crmData = {
  hero: {
    text: null,
    images: [],
    videoUrl: null,
    buttonUrl: null,
    buttonText: null,
    displaySectionMode: null,
  },
  landingHero: {
    hero: [
      {
        title: null,
        description: null,
        image: null,
        buttonUrl: null,
        buttonText: null,
      },
    ],
    videoUrl: null,
    displaySectionMode: null,
  },
  destinations: [],
  destination: {
    rating: null,
    title: null,
    locationName: {
      from: null,
      to: null,
    },
    originDestinations: [
      {
        from: null,
        to: null,
        departure: {
          date: null,
        },
      },
    ],
    image: null,
  },
  banner: [
    {
      image: null,
      link: null,
      fit: null,
    },
  ],
  CTA: {
    title: null,
    description: null,
    buttonText: null,
    link: null,
  },
  aboutUs: {
    backgroundImage: null,
    sections: [
      {
        image: null,
        title: null,
        description: null,
      },
    ],
    values: [
      {
        title: null,
        description: null,
      },
    ],
    blog: {
      text: null,
      link: null,
    },
  },
  contact: {
    backgroundImage: null,
    categories: [],
    workingDays: [
      {
        day: null,
        timeRange: [],
      },
    ],
    holidays: [
      {
        date: null,
        timeRange: [],
      },
    ],
    socials: [{ name: "", link: "" }],
    other: "",
  },
  terms: {
    title: "",
    heroImage: null,
    sections: [],
    faq: [{ question: null, answer: null }],
  },
  deals: {
    heroText: null,
    heroImage: null,
    flightList: [
      {
        dealsName: null,
        from: null,
        to: null,
        actualAmount: null,
        discountPercentage: null,
        icon: null,
      },
    ],
    hotelList: [
      {
        dealsName: null,
        location: null,
        actualAmount: null,
        discountPercentage: null,
        icon: null,
      },
    ],
    tourList: [
      {
        dealsName: null,
        destination: null,
        duration: null,
        actualAmount: null,
        discountPercentage: null,
        icon: null,
      },
    ],
  },
  testimonial: {
    heroText: null,
    heroImage: null,
    testimonials: [
      {
        profileImage: null,
        clientName: null,
        rating: null,
        title: null,
        review: null,
      },
    ],
  },

  flights: [
    {
      hero: [
        {
          title: null,
          description: null,
          image: null,
          buttonUrl: null,
          buttonText: null,
        },
      ],
      banner: [
        {
          image: null,
          link: null,
          fit: null,
        },
      ],
      quickInfo: [{ image: null, title: null, description: null }],
      sectionTitle: null,
      bannerTitle: null,
      videoUrl: null,
      flightList: [],
    },
  ],

  hotels: [{
    hero: [
      {
        title: null,
        description: null,
        image: null,
        buttonUrl: null,
        buttonText: null,
      },
    ],
    banner: [
      {
        image: null,
        link: null,
        fit: null,
      },
    ],
    quickInfo: [{ image: null, title: null, description: null }],
    videoUrl: null,
    sectionTitle: null,
    bannerTitle: null,
    hotelList: [
      {
        hotelName: null,
        location: null,
        image: null,
        hotelObj: {},
      },
    ],
  }],

  tours: [{
    hero: [
      {
        title: null,
        description: null,
        image: null,
        buttonUrl: null,
        buttonText: null,
      },
    ],
    banner: [
      {
        image: null,
        link: null,
        fit: null,
      },
    ],
    quickInfo: [{ image: null, title: null, description: null }],
    videoUrl: null,
    sectionTitle: null,
    bannerTitle: null,
    tourList: [
      {
        tourName: null,
        location: null,
        image: null,
        destinationId: null,
        tagId: null,
      },
    ],
  }],

  privacyPolicy: {
    heroText: null,
    policies: [],
  },
  externalLinks: [
    {
      title: null,
      urlLink: null,
      includesFooter: true,
    },
  ],
  visibility: {
    home: false,
    about: false,
    contact: false,
    terms: false,
    testimonial: false,
    privacypolicy: false,
    externalLink: false,
    flight: false,
    hotel: false,
    tour: false,
    faq: false,
  },
  homeLayoutSection: {
    flight: { isVisible: true, layout: null, title: null },
    hotel: { isVisible: true, layout: null, title: null },
    tour: { isVisible: true, layout: null, title: null },
    deals: { isVisible: true, layout: null, title: null },
    testimonial: { isVisible: true, layout: null, title: null },
    faq: { isVisible: true, layout: null, title: null },
    adGrid: { isVisible: true, layout: null, title: null },
    ourServices: { isVisible: true, layout: null, title: null },
    banner: { isVisible: true, layout: null, title: null },
    quickInfo: { isVisible: true, layout: null, title: null },
  },

  sectionOrder: [],

  topHotels: [
    {
      hotelName: null,
      location: null,
      image: null,
      hotelObj: {},
    },
  ],
  topTours: [
    {
      image: null,
      location: null,
      tourName: null,
      destinationId: null,
      tagId: null,
      tourObj: {},
    },
  ],
  adGridBanner: [
    {
      title: null,
      description: null,
      image: null,
      fit: null,
    },
  ],
  ourServices: [
    {
      title: null,
      description: null,
      content: null,
      icon: null,
    },
  ],
  homeTestimonial: [
    {
      profileImage: null,
      clientName: null,
      rating: null,
      title: null,
      review: null,
    },
  ],

  templateData: "",
};

//new
// destination: [{
//   title: '',
//   query: '',
//   image: null,
// }],
// quickInfo: [
//   {image: '',title: '',description: '',other: ''}
// ],
// banner: [{image: '',link: ''}],
